import { useTranslation } from 'react-i18next'

import { InputWithLabel, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InformationForCustomersConfiguration = ({
  returnsPolicyUrl,
  onChangeReturnsPolicyUrl,
  helpCenterUrl,
  onChangeHelpCenterUrl,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('Información para clientes')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Añade el link a la página de Política de devoluciones y a el centro de ayuda para clientes de tu web, que se mostrarán a los clientes en el Portal y en el panel de clientes.'
        )}
      </Text>
      <InputWithLabel
        value={returnsPolicyUrl}
        onChange={e => onChangeReturnsPolicyUrl(e.target.value)}
        label={t('URL Política de devoluciones')}
        placeholder="https://www.example.com/returnpolicy"
        fullWidth
      />
      <InputWithLabel
        value={helpCenterUrl}
        onChange={e => onChangeHelpCenterUrl(e.target.value)}
        label={t('URL Centro de ayuda para clientes')}
        fullWidth
      />
    </Styles.Container>
  )
}

export default InformationForCustomersConfiguration
